export default function attr(type) {
  return function (target, key) {
    const _type = type;
    if (!target.constructor.attributes) {
      target.constructor.attributes = {};
    }

    target.constructor.attributes[key] = _type;
  };
}
